import { createBeckyMaterializer, planners } from '@wix/thunderbolt-becky-materializer'
import { BaseDataItem, Data, DataMapName } from '@wix/thunderbolt-becky-types'

export const resolveData = (data: Data, translatedData: Data['document_data']) => {
	const beckyMaterializer = createBeckyMaterializer(planners)
	beckyMaterializer.batch(() => {
		Object.entries(data).forEach(([mapName, dataMap]) => {
			Object.entries(dataMap as Data[DataMapName]).forEach(([id, dataItem]) => {
				beckyMaterializer.updateData(mapName as DataMapName, id, dataItem as BaseDataItem<any>)
				if (mapName === 'document_data' && translatedData[id]) {
					beckyMaterializer.updateTranslationOverride(id, translatedData[id])
				}
			})
		})
	})

	const result = beckyMaterializer.get(['data'])
	return { ...data, ...result }
}
